import { Component } from 'react';
import cx from 'classnames';
import styles from '../../styles/rent.scss';
import { WebForm } from './webForm';
import { MobileForm } from './mobileForm';
import { trackAction } from '../../utils/trackActions';
import { scrollToTargetById } from '../../utils/commonUtils';
import { Api } from '../../api';

const api = new Api();

export default class RentForm extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      rent: '',
      address: '',
      name: '',
      email: '',
      owner: '',
      pan: '',
      datefrom: '',
      dateto: '',
      showForm2: false,
      formErrors: {
        email: '',
        rent: '',
        pan: '',
        name: '',
        address: '',
        owner: '',
        dateto: '',
        datefrom: '',
        dateError: '',
      },
      emailValid: false,
      nameValid: false,
      rentValid: false,
      addressValid: false,
      ownerValid: false,
      panValid: false,
      formValid: false,
      dateMarginValid: false,
      dateToValid: false,
      dateFromValid: false,
    };
  }
  public handleChange = (event: any) => {
    const target = event.target;
    const value = target.value;
    const name = target.name.toLowerCase();

    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };

  public toggleForm = () => {
    this.setState({
      showForm2: true,
    });
  };

  public formatDate = (dateStr: any) => {
    const formattedDate = dateStr
      .split('/')
      .reverse()
      .join('-');
    return formattedDate;
  };

  public validateField = (fieldName: any, value: any) => {
    const fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let nameValid = this.state.nameValid;
    let rentValid = this.state.rentValid;
    let addressValid = this.state.addressValid;
    let ownerValid = this.state.ownerValid;
    let panValid = this.state.panValid;
    let dateMarginValid = this.state.dateMarginValid;
    let dateToValid = this.state.dateToValid;
    let dateFromValid = this.state.dateFromValid;
    const dateRegex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
    const dateTo = this.formatDate(this.state.dateto);
    const dateFrom = this.formatDate(this.state.datefrom);

    switch (fieldName) {
      case 'email':
        emailValid = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value);
        fieldValidationErrors.email = emailValid ? '' : 'Email is invalid';
        break;
      case 'name':
        nameValid = value.length > 0;
        fieldValidationErrors.name = nameValid ? '' : 'Can not be empty';
        break;
      case 'rent':
        rentValid = /^\d+$/.test(value);
        fieldValidationErrors.rent = rentValid
          ? ''
          : 'You need to fill the amount in numbers';
        break;
      case 'address':
        addressValid = value.length > 0;
        fieldValidationErrors.address = addressValid ? '' : 'Can not be empty';
        break;
      case 'owner':
        ownerValid = value.length > 0;
        fieldValidationErrors.owner = ownerValid ? '' : 'Can not be empty';
        break;
      case 'pan':
        panValid = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(value);
        fieldValidationErrors.pan = panValid ? '' : 'Invalid Pan';
        break;
      case 'datefrom':
        dateFromValid = dateRegex.test(value);
        fieldValidationErrors.datefrom = dateFromValid
          ? ''
          : 'Invalid Start Date';
        break;
      case 'dateto':
        dateToValid = dateRegex.test(value);
        fieldValidationErrors.dateto = dateToValid ? '' : 'Invalid End Date';
        break;
      default:
        break;
    }

    if (dateFromValid && dateToValid) {
      const startDate = new Date(this.formatDate(dateFrom));
      const endDate = new Date(this.formatDate(dateTo));
      const isGreater = endDate > startDate;
      dateMarginValid = isGreater ? true : false;
    }
    fieldValidationErrors.dateError = dateMarginValid
      ? ''
      : 'Make sure end date is greater than start date';

    this.setState(
      {
        formErrors: fieldValidationErrors,
        emailValid,
        nameValid,
        rentValid,
        addressValid,
        ownerValid,
        panValid,
        dateFromValid,
        dateToValid,
        dateMarginValid,
      },
      this.validateForm
    );
  };

  public validateForm = () => {
    this.setState({
      formValid:
        this.state.emailValid &&
        this.state.nameValid &&
        this.state.rentValid &&
        this.state.addressValid &&
        this.state.ownerValid &&
        this.state.dateToValid &&
        this.state.dateFromValid &&
        this.state.dateMarginValid,
    });
  };

  public handleSubmit = (e: any, submitType: string) => {
    e.preventDefault();
    const formData = {
      rent_amount: Number(this.state.rent),
      customer_name: this.state.name,
      owner_name: this.state.owner,
      email_id: this.state.email,
      pan_id: this.state.pan,
      location_name: this.state.address,
      start_date: new Date(this.formatDate(this.state.datefrom)),
      end_date: new Date(this.formatDate(this.state.dateto)),
    };
    if (submitType === 'mobile') {
      api
        .getRentReceipt(formData)
        .then(response => {
          response.blob().then(blob => {
            api.handleDownloadFileResponse(blob, 'rent-receipt.pdf');
          });
        })
        .catch(err => JSON.stringify(err));
    }

    if (submitType === 'web') {
      api.getRentReceipt(formData);
      this.props.getReceipt();
      this.props.getReceiptData({
        ...this.state,
        datefrom: this.formatDate(this.state.datefrom),
        dateto: this.formatDate(this.state.dateto),
      });
      scrollToTargetById('results');
    }

    trackAction(
      'generate-receipt-click',
      'rent-receipts',
      JSON.stringify(this.state)
    );

    // Commenting code to persist user entered values
    // this.setState({
    //   rent: '',
    //   address: '',
    //   name: '',
    //   email: '',
    //   owner: '',
    //   pan: '',
    //   datefrom: '',
    //   dateto: '',
    // });
  };

  public render() {
    const { showForm2 } = this.state;
    return (
      <div
        className={cx(styles['rentreceipt-form-wrap'], {
          [styles.moveTotop]: showForm2,
        })}
        id="js-forms"
      >
        <WebForm
          data={this.state}
          handleChange={this.handleChange}
          toggleForm={this.toggleForm}
          handleSubmit={this.handleSubmit}
          formErrors={this.state.formErrors}
          formValid={this.state.formValid}
        />
        <MobileForm
          data={this.state}
          handleChange={this.handleChange}
          formErrors={this.state.formErrors}
          formValid={this.state.formValid}
          handleSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/rent/RentForm.tsx